import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			overflow: 'hidden',
		},
		grid: {
			justifyContent: 'center',
		},
		content: {
			maxWidth: theme.spacing(44.5),
		},
		item: {
			position: 'relative',
			display: 'flex',
			justifyContent: 'center',
			'&:first-child': {
				'& $divider': {
					display: ({ metaData }) => (metaData.columns?.toNumber() === 1 ? 'block' : undefined),
					[theme.breakpoints.up('xs')]: {
						display: 'none',
					},
				},
			},
			'&:last-child': {
				'& $divider': {
					display: ({ metaData }) => (metaData.columns?.toNumber() === 1 ? 'none' : undefined),
				},
			},
		},
		divider: ({ metaData }) => ({
			height: metaData.columns?.toNumber() === 1 ? undefined : 'calc(100% - 5rem)',
			bottom: metaData.columns?.toNumber() === 1 ? '0' : '2.5rem',
			background: '#979797',
		}),
		[theme.breakpoints.down('xs')]: {
			image: {
				maxHeight: theme.spacing(16),
				height: 'auto',
			},
		},
		[theme.breakpoints.up('lg')]: {
			'grid-lg-3': {
				'&:nth-child(5n)': {
					'& $divider': {
						display: 'none',
					},
				},
			},
			'grid-lg-4': {
				'&:nth-child(4n)': {
					'& $divider': {
						display: 'none',
					},
				},
			},
			'grid-lg-6': {
				'&:nth-child(odd)': {
					'& $divider': {
						display: 'none',
					},
				},
			},
		},
		[theme.breakpoints.only('md')]: {
			'grid-md-4': {
				'&:nth-child(4n)': {
					'& $divider': {
						display: 'none',
					},
				},
			},
			'grid-md-6': {
				'&:nth-child(odd)': {
					'& $divider': {
						display: 'none',
					},
				},
			},
		},
		[theme.breakpoints.only('sm')]: {
			'grid-sm-6': {
				'&:nth-child(odd)': {
					'& $divider': {
						display: 'none',
					},
				},
			},
		},
		[theme.breakpoints.only('xs')]: {
			'grid-xs-12': {
				'&:first-child': {
					'& $divider': {
						display: 'block',
					},
				},
				'&:last-child': {
					'& $divider': {
						display: 'none',
					},
				},
				'& $divider': {
					width: 'calc(100% - 5rem)',
					height: '1px',
					left: '2.5rem',
					bottom: 0,
				},
			},
		},
		text: {
			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData }) => `${metaData.mobileAlignment?.metaValue} !important`,
				},
			},
		},
	}),
	{ name: 'CallToAction-Cta4' },
)

export default useStyles
